var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "content-center",
    class: _vm.isMobile && 'wap-content-center'
  }, [_c('ComputeView'), _c('StakeView')], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };